import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import {
  inject,
  onMounted,
  onUnmounted,
  reactive,
  getCurrentInstance,
  computed,
  ref,
} from 'vue';

import { symbolTabsRootKey } from './constants';


const __default__ = {
  name: 'TabPanel',
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    label: {},
    name: {},
    disabled: { type: Boolean }
  },
  emits: ['click', 'disabled-click'],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const paneName = computed(() => props.name);
const index = ref<string>();
const instance = getCurrentInstance()!;

const tabsRoot = inject(symbolTabsRootKey);
if (!tabsRoot) throw new Error('header tabs error');

const active = computed(() => tabsRoot.currentName.value === props.name);

const pane = reactive({
  uid: instance.uid,
  disabled: props.disabled,
  paneName,
  active,
  index,
});

const tabPanelClickHandle = () => {
  if (pane.disabled) {
    emit('disabled-click');
    return;
  }
  // setCurrentName(tabName);
  if (!paneName.value || paneName.value === tabsRoot.currentName.value) return;

  tabsRoot.currentName.value = paneName.value;
  emit('click', tabsRoot.currentName.value);
};

onMounted(() => {
  tabsRoot.addChild(pane);
});

onUnmounted(() => {
  tabsRoot.removeChild(pane.uid);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["tab-panel__container", props.disabled ? 'disabled' : '']),
    onClick: tabPanelClickHandle
  }, [
    _createElementVNode("div", {
      class: _normalizeClass([active.value ? 'is-active' : '', "panel-label__wrap"])
    }, [
      _createElementVNode("span", null, _toDisplayString(_ctx.label), 1)
    ], 2)
  ], 2))
}
}

})